<app-modal-filler-atom
  (click)="close()"
  [index]="5"
></app-modal-filler-atom>
<div
  class="md:left-0' fixed left-0 right-0 mx-auto max-h-85-screen max-w-screen-sm overflow-y-auto md:top-0 md:flex md:h-full md:w-full md:items-center md:justify-center"
  [style.z-index]="750"
  [style.bottom.px]="keyboardOffset"
  [class.bottom-0]="keyboardOffset === 0"
>
  <div
    class="p-5 rounded-t-3xl md:rounded-3xl md:min-w-448"
    [class.pb-8]="isNotched"
    [style.z-index]="((index$ | async) ?? 0) + 50"
    [style.backgroundColor]="backgroundColor | contentBuilderColor"
    [style.color]="textColor | contentBuilderColor"
  >
    <div class="flex items-center justify-between">
      <h1 class="font-brand text-2xl font-bold">
        @if (title) {
          <span>
            {{ title }}
          </span>
        }
      </h1>
      <app-rounded-icon-button
        icon="icon-cross"
        [overrideColor]="buttonTextColor"
        [overrideBackgroundColor]="buttonBackgroundColor"
        (onClick)="close()"
      ></app-rounded-icon-button>
    </div>
    @if (message) {
      <div class="pt-8 pb-10 font-base text-base">
        {{ message }}
      </div>
    }
    <div>
      <app-button-atom
        [color]="'primary'"
        [label]="confirmButtonText"
        [type]="'primary'"
        [size]="'L'"
        [disabled]="isLoading"
        [iconUrl]="isLoading ? 'assets/images/spinner.svg' : ''"
        [overrideBgColor]="buttonBackgroundColor"
        [overrideTextColor]="buttonTextColor"
        (click)="submit()"
      >
      </app-button-atom>
    </div>
  </div>
</div>
